import Page from '@components/Page/Page'
import { AnalyticsProvider } from '@contexts/AnalyticsContext'
import ConversionSection from '@pages/venues/detail/tabs/overview/ConversionSection'
import { Permission } from '@utils/permissions'

const ConversionPage = () => {
  return (
    <AnalyticsProvider>
      <Page permissions={Permission.viewOverview}>
        <ConversionSection
          pageTitle={{ title: 'Reservation conversion', level: 4 }}
        />
      </Page>
    </AnalyticsProvider>
  )
}

export default ConversionPage
